// extracted by css-extract-rspack-plugin
export default {"Divider":"sputnik__Divider__WX1Fk","divider":"sputnik__Divider__WX1Fk"};